module.exports = __webpack_public_path__ + "img/analysis-disabled.8d14bc8a.png";